import { render, staticRenderFns } from "./ContributorList.vue?vue&type=template&id=6812e1bf"
import script from "./ContributorList.vue?vue&type=script&lang=js"
export * from "./ContributorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports